export default __webpack_public_path__ + "static/media/small-galaxis-logo.52c9c340.svg";